function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#AB6E4B",
  d: "M50,33.2c0,0,3.8-2.6,4-3.5s1.7-6.6,2.5-8.5 c0.7-1.9,2.5-7.3,2.5-7.3s2.7-1.2,4.9-0.8c2.2,0.5,4.7,1.4,4.7,1.4s-1.7,0.8-0.7,0.6c0.9-0.2,2.2,0.5,2.2,0.5l0.7,1.8l-1.6,14.4 c0,0,0,2.2,2.1,3.8c2.1,1.7,3,2.7,3,2.7s-12.3,0.3-14.1,0c-1.9-0.3-12.3-3.4-12.3-3.4L50,33.2z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7E4431",
  d: "M70.8,36.3c0,0-2.5-2.4-2.2-4.9C68.8,29,70.3,18,70.3,18 s-0.1-0.9-0.4-1.4c-0.3-0.6-1-0.7-1-0.7s0.1,1.5-0.3,3.3c-0.4,1.9-1.4,12.2-1.4,12.2s-0.3,3.4,1.2,4.8 C69.9,37.6,70.8,36.3,70.8,36.3z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7E4431",
  d: "M50.5,35.7c0,0,4.6-0.8,6.5-2.7c1.9-1.9,3.2-7.2,4-11.2 c0.7-4,1.3-6.7,1.3-6.7l0.7-0.8l3.5,0.5c0,0-1.7,7.5-2.1,10.4c-0.4,2.8-0.8,6.5-0.8,6.5s1.5-6,2-8.9c0.6-2.9,1.9-7.6,1.9-7.6 l0.9,0.8c0,0-2,10.3-2.5,13.3s-0.1,4.5,1.2,5.6c1.2,1.1,1,2.3,1,2.3L50.5,35.7z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#603120",
  d: "M55.1,36c0,0,2.3-1,3.9-3.8c1.6-2.8,3.1-11.3,3.4-12.8 c0.4-1.4,0.9-4.2,0.9-4.2l1.6-0.1c0,0-2.3,14.4-2.3,14.1s2.9-14.1,2.9-14.1l0.4-0.1c0,0-3.1,15.9-3.2,17c0,1.1,0.3,1.5,1.4,2.1 s2,0.7,2,0.7s-1.8-1.4-1.8-2.9c0-1.5,3.5-16.1,3.5-16.1l0.4,0.4c0,0-3,14.7-3,15.6s1.4,2.9,2.1,3.7s-7.7,0.8-8.1,0.8 C58.7,36.4,55.1,36,55.1,36z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#C2915E",
  d: "M48.9,34.8c0,0,4.5-2.9,5.3-4.4C55,29,58,17.9,58.6,16.2 s0.6-2.1,0.6-2.1s2-0.6,2.9-0.6c0.8,0,2.2,0.3,2.2,0.3s-4,0.6-4.5,1.1c-0.5,0.4-4.4,14.5-4.4,14.5s-1,2.3-3.2,3.8 C50.1,34.7,48.9,34.8,48.9,34.8z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#7E4431",
  d: "M52.4,35c-0.1,0,3.1-1.2,4-2.1c0.9-0.9,2-2.8,2.8-5.6 c0.8-2.7,2.7-12.5,2.7-12.5L60.7,15c0,0-2.4,10.6-3.8,13.8c-1.5,3.2-2.7,4-3.8,4.7C52,34.1,50.2,35,50.4,35s3-1.6,4.2-3 c1.2-1.4,1.9-3.2,2.6-5.7c0.7-2.5,2.7-10.2,2.7-10.2s-2.8,9.2-3.7,12.1s-4.1,5.6-6.6,7.1C47.1,36.7,52.5,35,52.4,35z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#E77523",
  d: "M59.5,34.9c0,0-9.3-1.4-14.2-0.1c0,0-13.8-1.1-24,4.8 c-10.2,6-26,18.9-18,39s28.1,30,66.6,29.2s53-26.2,48.8-43.5s-16.9-25.8-24.5-28.5S81.3,35,81.3,35S68.4,33.9,59.5,34.9z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#E06723",
  d: "M35.8,104.7c9.3,2.4,20.6,3.4,34.2,3.2 c22.6-0.4,36.9-9.4,44.1-20.2c-9.6,9.8-24.6,15.1-24.6,15.1s7.6-5.5,12.9-9.6s2.3-3.8-0.2-1.8c-2.6,2-4.9,2.2-7.5,2.2 s-2.7-0.1-7,4.7c-4.3,4.8-10.1,6.7-10.1,6.7s2.5-2.9,5.4-7.1s-1.7-0.5-5.5-0.4s-4.3-1.6-5.6,1.5c-1.3,3.1-4.7,7.6-4.7,7.6 s-0.1-3.9,0.5-7s-2.3-1.6-3.9-1.2c-1.7,0.4-4.2,0.2-7.3-0.7c-3-0.9-3.8-0.3-2.5,2.8c1.4,3.1,3.5,5.6,2.5,4.9s-5.3-2.4-8.4-6 s-3.6-3.2-5.8-3s-4-0.8-6.6-2.2c-2.6-1.4-1.9,0.3-0.2,3s6.9,7.6,6.9,7.6s-1-0.2-4.4-1.9c-3.4-1.6-6.7-8-8.3-10.2 c-1.6-2.3-1.6-0.2-4.3-0.8c-2.8-0.6-3.6-3.4-7.2-5c-3.5-1.6-2.1,2.1-2.1,2.1s3.4,6,7.9,8.8C27.9,100.7,32.3,103.1,35.8,104.7z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M87.8,105.4c25.1-6.9,34.5-26.7,31-41c-3-12.3-10.3-20.2-17-24.7 c0.4,0.3,10.9,8.3,14.7,20.5c3.9,12.5,1.5,20.4-5,29.3C106.6,96.2,98.3,101.2,87.8,105.4z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M32.2,35.7c-3.6,0.7-7.4,1.9-10.8,3.9c-10.2,6-26,18.9-18,39 c3.5,8.9,9.4,15.8,18.3,20.6c-13-7.3-23-25-16.8-41.1C11.3,41.6,31.8,35.8,32.2,35.7z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D35F20",
  d: "M41.5,36.1c0,0-8.9,4.8-13.7,17.2C23,65.6,25,94.8,41.3,104.6 c0,0-14.2-9-14.7-37.6c0,0,0.7-13.1,5.9-20.7C37.9,38.6,41.5,36.1,41.5,36.1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D35F20",
  d: "M59,36.1c0,0-8.8,5.1-13.7,17.9c-4.8,12.8-7.3,39.6,12.1,52 c0,0-12.7-7.8-13.2-37.7c0,0,0.7-13.7,5.9-21.7S59,36.1,59,36.1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D35F20",
  d: "M32.6,102.8c0,0-24.4-11.4-25.6-28.6 C5.8,56.9,18.1,43.7,18.1,43.7S6,54.1,5.4,70.9S22,97.7,32.6,102.8z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D35F20",
  d: "M89.4,102.8c0,0,24.4-11.4,25.6-28.6s-11.1-30.5-11.1-30.5 s12.1,10.4,12.7,27.2S100,97.7,89.4,102.8z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D35F20",
  d: "M81.6,37c0,0,16,10.8,12.3,36c-3.5,23.9-16.4,32-16.4,32 s13.9-5.2,17.8-28.6C98.8,44.3,81.6,37,81.6,37z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#D35F20",
  d: "M67.8,37.7c0,0,6.9,10.1,4.8,35.3c-2,23.9-5.5,33.6-5.5,33.6 s4.9-7.4,7.1-30.8C76.2,43.8,67.8,37.7,67.8,37.7z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M42.5,37.4c0,0,1.9-1.5,3.9-1.9s3.3-0.8,4.7-0.7s3.3,0.4,1.6,0.6 c-1.7,0.2-4.7,0.3-6.4,1.1C44.5,37.2,40.8,38.7,42.5,37.4z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M58.2,37.4c0,0,2.2-2,3.9-2.2s3.6-0.1,3.6-0.1s-1.3,0.4-3.2,0.8 c-1.9,0.4-3.2,1.8-4.1,2.4C57.5,39,56.2,39.8,58.2,37.4z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M39.5,35.8c0,0-9.4,0.8-12.7,2.4c-3.4,1.6-5.6,3-7.6,5.1 s-2.4,3.4-1.2,2.4c1.3-1,4.8-4,7.7-5.2c2.8-1.2,6.5-2.7,8.8-2.7C36.7,37.7,40.9,35.8,39.5,35.8z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M77.4,35.5c0,0-5.4-0.4-7-0.2s-1.5,0.6-1.2,1.3s1.4,2.2,1.6,1.7 s-0.6-2,1-2.2s2.9-0.3,4.5-0.2c1.5,0.2,3,0.7,3,0.7S79.7,35.8,77.4,35.5z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#F7971D",
  d: "M84,35.6c0,0,4-1.1,7.7-0.2c3.7,1,5.2,1.7,5.2,1.7s-1.2-0.2-4-0.8 s-4-0.7-5.5-0.6C85.9,36,81.7,35.9,84,35.6z"
}));

var Svg2 = function Svg2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    enableBackground: "new 0 0 120 120",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/2.3f4b6524.svg";
export { ForwardRef as ReactComponent };